import ReactLoading from 'react-loading';
import "./LoadingScreen.css";

function LoadingScreen() {
  return (
    <div id="loading-screen">
      <div id="loading-screen-spinner">
        <ReactLoading type={"spin"} color={"#28a745"} height={64} width={64} className="loadingScreenSpinner" />
      </div>
    </div>
  )
}

export default LoadingScreen
